import React from "react";
import { Form, LabelInput } from "../../common/components/form";
import { StyledFormFooter } from "../../common/components/form/ui";
import Button from "../../../ui/button/Button";

import { Localize } from "../../../locale/localization";

const RegisterUserForm = props => {
  const {
    enabled,
    onSubmit,
    onBlur,
    onInputChange,
    errors,
    touchedFields,
    isValid,
    firstName,
    lastName,
    address,
    zipcode,
    city,
    password,
    passwordConfirm,
    email //readonly
  } = props;

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      <LabelInput
        half
        type="text"
        label="Etunimi"
        name="firstName"
        value={firstName}
        error={errors["firstName"] && touchedFields.indexOf("firstName") > -1}
        errorMessage={errors["firstName"]}
        onChange={onInputChange}
      />
      <LabelInput
        half
        type="text"
        label="Sukunimi"
        name="lastName"
        value={lastName}
        error={errors["lastName"] && touchedFields.indexOf("lastName") > -1}
        errorMessage={errors["lastName"]}
        onChange={onInputChange}
      />
      <LabelInput
        type="text"
        label="Katuosoite"
        name="address"
        value={address}
        error={errors["address"] && touchedFields.indexOf("address") > -1}
        errorMessage={errors["address"]}
        onChange={onInputChange}
      />
      <LabelInput
        half
        type="text"
        label="Postinumero"
        name="zipcode"
        value={zipcode}
        error={errors["zipcode"] && touchedFields.indexOf("zipcode") > -1}
        errorMessage={errors["zipcode"]}
        onChange={onInputChange}
      />
      <LabelInput
        half
        type="text"
        label="Postitoimipaikka"
        name="city"
        value={city}
        error={errors["city"] && touchedFields.indexOf("city") > -1}
        errorMessage={errors["city"]}
        onChange={onInputChange}
      />
      {/*<Label label="Käyttäjätunnuksesi (sähköpostiosoite)">
        <StyledStaticField>{email}</StyledStaticField>
      </Label>*/}
      <LabelInput
        readOnly
        label="Käyttäjätunnuksesi (sähköpostiosoite)"
        type="email"
        name="email"
        value={email}
      />
      <LabelInput
        label="Salasana"
        name="password"
        type="password"
        value={password}
        error={errors["password"] && touchedFields.indexOf("password") > -1}
        errorMessage={errors["password"]}
        onChange={onInputChange}
      />
      <LabelInput
        label={Localize("password.again")}
        name="passwordConfirm"
        type="password"
        value={passwordConfirm}
        error={errors["passwordConfirm"] && touchedFields.indexOf("passwordConfirm") > -1}
        errorMessage={errors["passwordConfirm"]}
        onChange={onInputChange}
      />
      <StyledFormFooter centered>
        <Button
          disabled={!isValid || !enabled}
          type="submit"
          icon="#chevron-right"
          iconRight={true}
        >
          {Localize("action.join")}
        </Button>
      </StyledFormFooter>
    </Form>
  );
};

export default RegisterUserForm;



// WEBPACK FOOTER //
// ./src/modules/user/components/RegisterUserForm.js